import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'

import Image from '../components/UI/Image'

import styles from '../styles/sections/About.module.css'

const About = props => {
  return (
    <section id={props.markdownRemark.frontmatter.id} className={styles.section}>
      <div className={styles.container}>
        <div className={styles.imageWrapper}>
          <div className={styles.imageAspectRatio}>
            <div className={styles.imageContent}>
              <Image
                fluid={props.truck.childImageSharp.fluid}
                className={`${styles.image1} ${styles.imageBlock}`}
              />
              <Image
                fluid={props.truck2.childImageSharp.fluid}
                className={`${styles.image2} ${styles.imageBlock}`}
              />
              <div className={`${styles.greenBlock} ${styles.imageBlock}`} aria-hidden={true} />

              <Image
                fluid={props.warehouse.childImageSharp.fluid}
                className={`${styles.image3} ${styles.imageBlock}`}
              />
              <Image
                fluid={props.aerialView.childImageSharp.fluid}
                className={`${styles.image4} ${styles.imageBlock}`}
              />
              <Image
                fluid={props.truck3.childImageSharp.fluid}
                className={`${styles.image5} ${styles.imageBlock}`}
              />

              <div className={`${styles.yellowBlock} ${styles.imageBlock}`} aria-hidden={true} />
              <Image
                fluid={props.warehouse2.childImageSharp.fluid}
                className={`${styles.image6} ${styles.imageBlock}`}
              />
            </div>
          </div>
        </div>

        <div className={styles.textWrapper}>
          <h2 className={styles.title}>
            {props.markdownRemark.frontmatter.title}
            <small className={styles.subtitle}>{props.markdownRemark.frontmatter.subtitle}</small>
          </h2>

          <div
            className={styles.text}
            dangerouslySetInnerHTML={{ __html: props.markdownRemark.html }}
          />
        </div>
      </div>
    </section>
  )
}

About.propTypes = {
  markdownRemark: PropTypes.shape({
    frontmatter: PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      subtitle: PropTypes.string
    }),
    html: PropTypes.string
  }),
  truck: PropTypes.shape({
    childImageSharp: PropTypes.shape({
      fluid: PropTypes.object
    })
  }),
  truck2: PropTypes.shape({
    childImageSharp: PropTypes.shape({
      fluid: PropTypes.object
    })
  }),
  warehouse: PropTypes.shape({
    childImageSharp: PropTypes.shape({
      fluid: PropTypes.object
    })
  }),
  aerialView: PropTypes.shape({
    childImageSharp: PropTypes.shape({
      fluid: PropTypes.object
    })
  }),
  truck3: PropTypes.shape({
    childImageSharp: PropTypes.shape({
      fluid: PropTypes.object
    })
  }),
  warehouse2: PropTypes.shape({
    childImageSharp: PropTypes.shape({
      fluid: PropTypes.object
    })
  })
}

const aboutQuery = graphql`
  query AboutQuery {
    markdownRemark(frontmatter: { id: { eq: "about" } }) {
      frontmatter {
        id
        title
        subtitle
      }
      html
    }
    truck: file(relativePath: { eq: "about/caminhao.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    truck2: file(relativePath: { eq: "about/caminhao-2.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    warehouse: file(relativePath: { eq: "about/deposito.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    aerialView: file(relativePath: { eq: "about/vista-aerea-do-deposito.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    truck3: file(relativePath: { eq: "about/caminhao-3.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    warehouse2: file(relativePath: { eq: "about/deposito-2.jpg" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

export default () => <StaticQuery query={aboutQuery} render={data => <About {...data} />} />
